export default __webpack_public_path__ + "static/integrateTheme-3183ee4096ea2a32c6bf971740ea4797.svg";